import { render } from "./OffcanvasModifierForm.vue?vue&type=template&id=2cfbfa9e&scoped=true"
import script from "./OffcanvasModifierForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasModifierForm.vue?vue&type=script&lang=js"

import "./OffcanvasModifierForm.vue?vue&type=style&index=0&id=2cfbfa9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfbfa9e"]])

export default __exports__